module.exports = __webpack_public_path__ + "img/Budget.ea69417d.svg";